import { amaiConfig } from './brand/amai';
import { wotuConfig } from './brand/wotu';
import { eduConfig } from './brand/edu';
import { gxzsConfig } from './brand/gxzs';
import { aigceduConfig } from './brand/aigcedu';
import { briadConfig } from './brand/broadcasting';
import { arkConfig } from './brand/ark';
import { juxflowConfig } from './brand/juxflow';
import type { BrandConfig } from './brand/types';

export type { BrandConfig, CreationTabKey, AgreementTab, LogoDisplay } from './brand/types';

/** 完整域名 → 品牌配置（精确匹配，避免子域名截取歧义） */
const hostnameMap: Record<string, BrandConfig> = {
  'aifilm.busionline.com': wotuConfig,
  'edu.ame-film.com': eduConfig,
  'aifilm.gxzs.top': gxzsConfig,
  'ai.aigc-edu.org.cn': aigceduConfig,
  'blnyc.ame-film.com': briadConfig,
  'film.wjark.com': arkConfig,
  'juxflow.ame-film.com': juxflowConfig,
};

export const DEFAULT_BRAND = amaiConfig;

/** brand key → 品牌配置（用于 ?brand=xxx 调试覆盖） */
const brandKeyMap: Record<string, BrandConfig> = {
  amai: amaiConfig,
  wotu: wotuConfig,
  edu: eduConfig,
  gxzs: gxzsConfig,
  aigcedu: aigceduConfig,
  blnyc: briadConfig,
  ark: arkConfig,
  juxflow: juxflowConfig,
};

export function resolveBrand(): BrandConfig {
  // 开发/测试环境支持 ?brand=xxx URL 参数快速切换品牌
  if (import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'test') {
    const params = new URLSearchParams(window.location.search);
    const brandKey = params.get('brand');
    if (brandKey && brandKeyMap[brandKey]) {
      return brandKeyMap[brandKey];
    }
  }
  const hostname = window.location.hostname;
  return hostnameMap[hostname] ?? DEFAULT_BRAND;
}
